/**
 * @internal
 */
import { useCallback, useState } from 'react';
const useCallbackRef = () => {
    const [node, setNode] = useState(null);
    const ref = useCallback((node) => {
        setNode(node);
    }, []);
    return [ref, node];
};
export default useCallbackRef;
